/**Tipos de cliente SAP */
export enum SAPClientType {
    Residencial = "RES",
    Comercial = "COM"
}